import { render, staticRenderFns } from "./designerInfo.vue?vue&type=template&id=bdcc613c&scoped=true&"
import script from "./designerInfo.vue?vue&type=script&lang=js&"
export * from "./designerInfo.vue?vue&type=script&lang=js&"
import style0 from "./designerInfo.vue?vue&type=style&index=0&id=bdcc613c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc613c",
  null
  
)

export default component.exports